module.exports = __webpack_public_path__ + "img/guideC.83265dd9.png";